import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const FlightService = {
  getAllFlights: async () => {
    return await api.get("/flight");
  },
};
export default FlightService;
